import {
  CodePostalDto,
  PanelSection,
  ParametreDto,
  ParametresGlobauxDto,
  ParametresEmailDto,
  ParametresGoogleDto,
  ParcDto,
  PaysDto,
  PictogrammeDto,
  TypeConteneurMobileDto,
  TypeDechetDto,
  TypeDechetRwdto,
  UniteMesureDto,
  ZoneGeographiqueDto,
  TypeIncidentDto,
  ParametresAzureDto,
  CategorieDocumentDto,
  TypeAccesPersonneMoraleDto,
  FormeJuridiqueDto,
  ExutoireDto,
  ConteneurDto,
  ConteneurMobileDto,
  TransporteurDto,
  DispatchExutoireDto,
  DispatchTransporteurDto,
  ParcDetailsDto,
  EmplacementStockDto,
  ArticleDto,
  TypeEvacuationDto,
  ThemeDto,
  ParametresJokerDto,
  ParametresRepresentantDto,
  TypeElementStockDto
} from 'src/api/models';

export interface ControlPanelState {
  isLoggedIn: boolean;
  userName: string;
  userId: number;
  parcId: number;
  parc: ParcDetailsDto;
  transporteurId: number;
  personnePhysiqueId: string,
  permissions: string[];
  roles: string[];
  language: string;
  token: string;
  navigation: PanelSection[];
  allParams: ParametreDto[];
  globalParams: ParametresGlobauxDto;
  emailParams: ParametresEmailDto;
  googleParams: ParametresGoogleDto;
  azureParams: ParametresAzureDto;
  jokerParams: ParametresJokerDto;
  representantParams: ParametresRepresentantDto;
  logo: Blob;
  codesPostaux: CodePostalDto[];
  codesPostauxAcceptes: CodePostalDto[];
  pays: PaysDto[];
  typesIncidents: TypeIncidentDto[];
  typesDechets: TypeDechetDto[];
  typesDechetsRW: TypeDechetRwdto[];
  unitesMesure: UniteMesureDto[];
  parcs: ParcDto[];
  exutoires: ExutoireDto[];
  conteneurs: ConteneurDto[];
  conteneursMobile: ConteneurMobileDto[];
  signalR: boolean;
  zonesGeographiques: ZoneGeographiqueDto[];
  typesConteneursMobiles: TypeConteneurMobileDto[];
  pictogrammes: PictogrammeDto[];
  categoriesDocument: CategorieDocumentDto[];
  typesAcces: TypeAccesPersonneMoraleDto[],
  formesJuridiques: FormeJuridiqueDto[],
  transporteurs: TransporteurDto[],
  dispatchExutoires: DispatchExutoireDto[],
  dispatchTransporteurs: DispatchTransporteurDto[],
  emplacements: EmplacementStockDto[],
  articles: ArticleDto[],
  typesEvacuations: TypeEvacuationDto[];
  themes : ThemeDto[];
  typesElementsStock : TypeElementStockDto[];

  error: any;
}

export const ControlPanelStateDefault = {
  isLoggedIn: false,
  userName: null,
  userId: null,
  parcId: null,
  parc: null,
  transporteurId: null,
  personnePhysiqueId: null,
  roles: null,
  permissions: null,
  language: null,
  token: null,
  sideMenuOpen: true,
  navigation: null,
  allParams: null,
  globalParams: null,
  emailParams: null,
  googleParams: null,
  azureParams: null,
  jokerParams: null,
  representantParams: null,
  logo: null,
  codesPostaux: null,
  codesPostauxAcceptes: null,
  pays: null,
  typesIncidents: null,
  typesDechets: null,
  typesDechetsRW: null,
  unitesMesure: null,
  parcs: null,
  exutoires: null,
  conteneurs: null,
  conteneursMobile: null,
  signalR: false,
  zonesGeographiques: null,
  typesConteneursMobiles: null,
  pictogrammes: null,
  categoriesDocument: null,
  typesAcces: null,
  formesJuridiques: null,
  transporteurs: null,
  dispatchExutoires: null,
  dispatchTransporteurs: null,
  emplacements: null,
  articles: null,
  typesEvacuations: null,
  themes: null,
  typesElementsStock: null,
  error: null
};
